//  http://localhost:3001
// https://mnet-3c33.vercel.app

const API_BASE_URL = "https://mnet-3c33.vercel.app";

export default API_BASE_URL;
 